module.exports = __webpack_public_path__ + "static/img/menu_icon6.3cae076f.png";